import React from 'react';
import Modal from 'react-modal';
import LinearProgress from '@mui/material/LinearProgress';

interface Props {
  isOpen: boolean;
  heading: string;
  children?: React.ReactNode;
  progress: number;
}
const LoadingModal = (props: Props) => {
  return (
    <Modal
      className='text-center transform  m-auto translate-y-1/2	w-2/5 border border-gray-400 rounded-md pt-10 p-8 bg-gray-50'
      isOpen={props.isOpen}
      appElement={document.getElementById('app-root') as HTMLElement}
      id='loading-modal'
      data-locator='modal'
    >
      <h2 className='text-2xl font-semibold'>{props.heading}</h2>
      <LinearProgress variant="determinate" value={props.progress} color='inherit' className='mt-8'
        id='loading_modal_progress' sx={{ color: '#ac542e' }} />
    </Modal>
  );
};
export default LoadingModal;
